import React from "react";
import { CONSTANTS, SOCIAL_SOURCES } from "../../../constants/app-constant";
import { Table } from "react-bootstrap";
const { DATA_NOT_FOUND } = CONSTANTS;
const { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE, PINTEREST } = SOCIAL_SOURCES;

const TopPostersChart = ({
  chartTitle,
  data,
  entityList,
  reportType,
  onEntityClick,
  identifier,
  dataByReportType,
  type,
}) => {
  const handleUsernameClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    data && window.open(`https://twitter.com/${data}`, "_blank");
  };

  const handleCountClick = (e, legend, label, from_username, channelType) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.from_username = from_username;
      routeParams.channel_type = [channelType];
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className="customTableWrap">
      <div className="widgetHeading">Top Posters</div>
      <div className="table-responsive">
        <Table className="table table-sm table-bordered customTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Entity</th>
              <th>Platform</th>
              <th>No. Of Posts</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data.map((el) => {
                const {
                  from_username,
                  count,
                  topic_id,
                  topic_category,
                  topic_name,
                  channel_type,
                } = el || {};
                return (
                  <React.Fragment key={topic_id}>
                    <tr>
                      <td>
                        {channel_type == TWITTER ? (
                          <strong>
                            <a
                              className="influencersLink"
                              onClick={(e) =>
                                handleUsernameClick(e, from_username)
                              }
                            >
                              {`@${from_username}`}
                            </a>
                          </strong>
                        ) : (
                          from_username || "Other"
                        )}
                      </td>
                      <td>{topic_name}</td>
                      {channel_type == FACEBOOK && <td>Facebook</td>}
                      {channel_type == INSTAGRAM && <td>Instagram</td>}
                      {channel_type == TWITTER && <td>X</td>}
                      {channel_type == YOUTUBE && <td>Youtube</td>}
                      {/* {channel_type == PINTEREST && <td>Pinterest</td>} */}
                      <td>
                        {" "}
                        <strong>
                          <a
                            className="influencersLink"
                            onClick={(e) =>
                              handleCountClick(
                                e,
                                null,
                                topic_name,
                                from_username,
                                channel_type
                              )
                            }
                          >
                            {`${count}`}
                          </a>
                        </strong>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TopPostersChart;
